import { render } from "./CheckmarkOutlined.vue?vue&type=template&id=396ecf9e"
const script = {}
script.render = render

export default script